/* Rêve: type-to-find inside long filter groups (Designer, Size, Category).
   Injected by JS rather than Liquid so the theme's AJAX re-render of the filter
   blocks (facets.js -> "collection:rerendered") can simply re-inject. The input
   has no name, so it never reaches FormData, and its input events are stopped in
   the capture phase so facet-filters-form does not treat a keystroke as a
   filter change and reload the grid. */
(function () {
  var MIN_ITEMS = 8;
  var INPUT = 'reve-facet-search__input';

  function inject() {
    var lists = document.querySelectorAll('.f-facets__block-content .f-facets__list:not(.f-facets__list--color):not(.f-facets__images)');
    Array.prototype.forEach.call(lists, function (ul) {
      var content = ul.closest('.f-facets__block-content');
      if (!content || content.querySelector('.reve-facet-search')) return;
      if (ul.querySelectorAll('.f-facets__item').length <= MIN_ITEMS) return;
      var block = content.closest('.f-facets__block');
      var labelEl = block && block.querySelector('.f-facets__block-header span');
      var label = labelEl ? labelEl.textContent.trim() : 'options';
      var wrap = document.createElement('div');
      wrap.className = 'reve-facet-search';
      var input = document.createElement('input');
      input.type = 'search';
      input.className = INPUT;
      input.placeholder = 'Search ' + label.toLowerCase();
      input.setAttribute('aria-label', 'Search ' + label);
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('spellcheck', 'false');
      wrap.appendChild(input);
      ul.parentNode.insertBefore(wrap, ul);
    });
  }

  function apply(input) {
    var content = input.closest('.f-facets__block-content');
    if (!content) return;
    var q = input.value.trim().toLowerCase();
    var items = content.querySelectorAll('.f-facets__item');
    Array.prototype.forEach.call(items, function (li) {
      var hit = q && (li.textContent || '').toLowerCase().indexOf(q) !== -1;
      li.classList.toggle('reve-search-hit', !!hit);
    });
    content.classList.toggle('reve-searching', !!q);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains(INPUT)) return;
    e.stopPropagation();
    apply(t);
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains(INPUT) && e.key === 'Enter') e.preventDefault();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  document.addEventListener('collection:rerendered', inject);
})();
